import { configureStore } from '@reduxjs/toolkit';
import { referenceDataSlice, factListSlice, loaderSlice, toasterSlice, routeSlice, accessTokenSlice, clientSlice, clientListSlice } from 'redux/reducers';

export default configureStore({
	reducer: {
		referenceData: referenceDataSlice.reducer,
		factList: factListSlice.reducer,
		loader: loaderSlice.reducer,
		toaster: toasterSlice.reducer,
		route: routeSlice.reducer,
		acState: accessTokenSlice.reducer,
		clientData: clientSlice.reducer,
		clientList: clientListSlice.reducer
	}
});
